/** множественная форма */
export function plural(skey: string, dkey: string, pkey: string, n: number): string {
  // eslint-disable-next-line no-nested-ternary
  return n % 10 === 1 && n % 100 !== 11
    ? skey
    : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
      ? dkey
      : pkey;
}
